import { Col, Divider, Pagination, Row, Typography } from "antd";
import React, { FC, useEffect, useState, useMemo, useCallback } from "react";
import RealStateCardViewItem from "../Common/CardViewIem";
import MapLocationList from "../MapItems/MapIndex";
import TopOptions from "./Components/TopOptions";
import LeftDetailsFilter from "./Components/LeftDetailsFilter";
import RealStateListViewItem from "../Common/ListViewItem";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import TreeCategories from "./Components/TreeCategories";
import { useGetAdverts } from "./ServerSideStates";
import { excludeFilterPropertiesOnRequest } from "helpers/ExcludeAdvertFilter";
import PageTitle from "./PageTitle";
import CustomNoData from "apps/Common/CustomNoData";
import { useQueryClient } from "react-query";
import searchEndPoints from "apps/layout/Header/EndPoints";
import { useLocation, useSearchParams } from "react-router-dom";
import GeneralLoadingSpinner from "apps/Common/GeneralLoadingSpinner";
import MobileBreadcrumb from "./Components/MobileBreadcrumb";
import MobileTopOptions from "./Components/MobileTopOptions";
import FilterTags from "./Components/FilterTags";
import { handleSetAdvertListFilter } from "./ClientStates";
import StatusViewingMap from "../MapItems/Components/StatusViewingMap";
import { getAdvertListFilter } from "../../News/Services";

const WrapperAdvertList: FC<{ type: string; children: any }> = ({
  type,
  children,
}) => {
  return (
    <>
      {type === "cart" ? (
        <Row
          gutter={[
            { xs: 10, sm: 20, md: 25, lg: 30, xl: 35, xxl: 40 },
            { xs: 10, sm: 20, md: 25, lg: 30, xl: 35, xxl: 40 },
          ]}
        >
          {children}
        </Row>
      ) : (
        <Row gutter={[
          { xs: 10, },
          { xs: 10, },
        ]}>{children}</Row>
      )}
    </>
  );
};

const RealStateListIndex = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { Text } = Typography;
  const { viewingModes, filter } = useSelector(
    (state: RootState) => state.realState
  );
  const queryClient = useQueryClient();

  // URL parametrelerinden filtre oluştur
  const urlFilterParams = useMemo(() => {
    const categoryId = searchParams.get('CategoryId');
    const cityId = searchParams.get('CityId');
    const districtIds = searchParams.get('DistrictIds');
    const neighbourhoodIds = searchParams.get('NeighbourhoodIds');
    console.log("URL Filter Params:", {
      CategoryId: categoryId,
      CityId: cityId,
      DistrictIds: districtIds,
      NeighbourhoodIds: neighbourhoodIds
    });

    return {
      CategoryId: categoryId ? Number(categoryId) : undefined,
      CityId: cityId ? Number(cityId) : undefined,
      DistrictIds: districtIds ? [Number(districtIds)] : undefined,
      NeighbourhoodIds: neighbourhoodIds ? [Number(neighbourhoodIds)] : undefined
    };
  }, [searchParams]);

  const [allAdvertData, setAllAdvertData] = useState<any>([]);
  const [isLocationStateProcessed, setIsLocationStateProcessed] = useState(false);

  // React Query ile veri çekme
  const adverts = useGetAdverts(excludeFilterPropertiesOnRequest(filter));

  // URL parametreleri ve location.state ile filtreleme
  useEffect(() => {
    const handleFilterAndFetch = async () => {
      let finalFilterParams = { ...urlFilterParams };
      console.log("Final Filter Params:", finalFilterParams);
      let shouldFetchFromAPI = true;

      // location.state varsa önce onu işle
      if (location.state && !isLocationStateProcessed) {
        const { filterData, appliedFilters } = location.state;
        
        if (filterData && appliedFilters) {
          const updatedFilter = {
            ...appliedFilters,
            PageIndex: 1,
            PageSize: 20,
          };
          console.log("Updated Filter from Location State:", updatedFilter);
          dispatch(handleSetAdvertListFilter({ filter: updatedFilter }));
          
          // Eğer filterData varsa API çağrısı yapmaya gerek yok
          if (filterData?.data || filterData) {
            setAllAdvertData(filterData?.data || filterData);
            shouldFetchFromAPI = false;
          }
          
          finalFilterParams = updatedFilter;
        }
        setIsLocationStateProcessed(true);
      }

      // URL parametreleri varsa ve API çağrısı gerekiyorsa
      if (shouldFetchFromAPI && Object.values(urlFilterParams).some(val => val !== undefined)) {
        try {
          const response = await getAdvertListFilter(finalFilterParams);
          console.log("API Response:", response);
          if (response?.success) {
            setAllAdvertData(response.data?.data || []);
          }
        } catch (error) {
          console.error('Filter error:', error);
        }
      }
    };

    handleFilterAndFetch();
  }, [searchParams, location.state, dispatch, urlFilterParams, isLocationStateProcessed]);

  // React Query sonuçlarını işle (sadece location.state yoksa)
  useEffect(() => {
    if (!location.state && !adverts.isLoading && adverts?.data?.data?.data) {
      setAllAdvertData(adverts?.data?.data?.data);
    }
  }, [adverts.data, location.state, adverts.isLoading]);

  // Search filter cleanup
  useEffect(() => {
    if (filter?.IsSearchFilter) {
      const timeout = setTimeout(() => {
        queryClient.resetQueries({
          queryKey: searchEndPoints.getUserLastSearch,
          exact: false,
        });
      }, 2000);
      return () => clearTimeout(timeout);
    }
  }, [location.pathname, filter?.title, queryClient]);

  // Pagination handler
  const handleChangePagination = useCallback((pageNum: number, pageSize: number) => {
    const newFilter = { ...filter, PageIndex: pageNum, PageSize: pageSize };
    dispatch(handleSetAdvertListFilter({ filter: newFilter }));
  }, [filter, dispatch]);

  // Loading durumunu hesapla
  const isLoading = useMemo(() => {
    return (adverts.isLoading || adverts.isFetching) && !location.state;
  }, [adverts.isLoading, adverts.isFetching, location.state]);

  return (
    <>
      <Col span={24} className="!overflow-hidden mb-5">
        <Row
          gutter={[
            { xs: 10, md: 15, xl: 20, xxl: 20 },
            { xs: 0, md: 5, xl: 10, xxl: 20 }
          ]}
          className=""
        >
          {filter?.CategoryId ||
            (filter?.IsSearchFilter && (filter?.CategoryId || filter?.Title)) ? (
            <>
              <Col span={24} className="!flex justify-center mt-5 mb-3">
                <PageTitle />
              </Col>
            </>
          ) : (
            <div className="!flex justify-center">
              <></>
            </div>
          )}

          <Col xs={24} className="!flex justify-center xl:!hidden !mb-2 md:!mb-2">
            <MobileBreadcrumb />
          </Col>
          <Col xs={24} className="!block xl:!hidden">
            <MobileTopOptions />
          </Col>

          <Col className="!flex gap-2 !flex-nowrap xl:!hidden !overflow-x-auto !mt-4 xl:!mt-0">
            <FilterTags isMobile={true} />
          </Col>

          <Col span={24}>
            <Row gutter={[60, 0]}>
              <Col xs={24} lg={5} className="">
              
                <Row gutter={[20, 20]} className="bg-white p-5 rounded-xl shadow-sm">
                  <Col xs={24} className="!hidden xl:!block">
                    <TreeCategories />
                  </Col>
                  {filter?.CategoryId || filter?.IsSearchFilter ? (
                    <Col xs={24} className="!hidden xl:!block">
                      <LeftDetailsFilter isMobile={false} />
                    </Col>
                  ) : (
                    <Col xs={24}>
                      <></>
                    </Col>
                  )}
                </Row>
              </Col>

              <Col xs={24} lg={19}>
                {filter?.CategoryId || filter?.IsSearchFilter ? (
                  <Row gutter={[0, 0]}>
                    <Col xs={24} className="!hidden xl:!block">
                      <TopOptions />
                    </Col>
                    {viewingModes === "list" && (
                      <Row className="w-full !bg-gray-300 !py-2 !px-4 !mb-0 !mt-5 !rounded-t-lg !text-xs !font-bold !text-gray-600">
                        <Col md={6} xl={4} className="!pl-4"></Col>
                        <Col md={18} xl={20}>
                          <Row>
                            <Col md={10} className="!pl-4">İlan Başlığı</Col>
                            <Col md={14}>
                              <Row>
                                <Col lg={10} className="!hidden lg:!block">Özellikler</Col>
                                <Col lg={6} className="!hidden lg:!block">Lokasyon</Col>
                                <Col lg={8} className="!hidden lg:!block text-end">Tarih & İşlemler</Col>
                              </Row>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    )}

                    {(() => {
                      if (viewingModes === "cart" || viewingModes === "list") {
                        return (
                          <>
                            <Col span={24} className="">
                              <Row gutter={[0, viewingModes === "list" ? 10 : 0]}>
                                <Col xs={24} className="bg-white rounded-md p-3 mt-5">
                                  <WrapperAdvertList type={viewingModes}>
                                    <>
                                      {isLoading && <GeneralLoadingSpinner />}
                                      {allAdvertData.length > 0 ? (
                                        <>
                                          {allAdvertData.map((item: any, index: number) => {
                                            return (
                                              <React.Fragment key={item.id || index}>
                                                <Col 
                                                  style={viewingModes === "list" ? { 
                                                    borderRadius: "6px", 
                                                    border: "1px solid #dedede", 
                                                    marginBottom: '10px', 
                                                    marginTop: '10px' 
                                                  } : {}}
                                                  xs={viewingModes === "cart" ? 12 : 24}
                                                  md={viewingModes === "cart" ? 12 : 24}
                                                  lg={viewingModes === "cart" ? 6 : 24}
                                                  className="hover:cursor-pointer"
                                                >
                                                  {viewingModes === "cart" ? (
                                                    <RealStateCardViewItem
                                                      data={allAdvertData}
                                                      setData={setAllAdvertData}
                                                      item={item}
                                                      advertType={item.type === 0 ? "realState" : "vehicle"}
                                                    />
                                                  ) : (
                                                    <RealStateListViewItem
                                                      data={allAdvertData}
                                                      setData={setAllAdvertData}
                                                      item={item}
                                                      advertType={item.type === 0 ? "realState" : "vehicle"}
                                                    />
                                                  )}
                                                </Col>
                                              </React.Fragment>
                                            );
                                          })}
                                        </>
                                      ) : (
                                        <CustomNoData />
                                      )}
                                    </>
                                  </WrapperAdvertList>
                                </Col>
                                <Col xs={24} className="!flex !justify-center md:!justify-end">
                                  <Pagination
                                    onChange={handleChangePagination}
                                    total={adverts?.data?.data?.filteredCount || 0}
                                    pageSize={adverts?.data?.data?.pageSize || 20}
                                    current={adverts?.data?.data?.pageIndex || 1}
                                    showLessItems={true}
                                    size={"small"}
                                    showSizeChanger={true}
                                    locale={{ items_per_page: "" }}
                                    showTotal={(e) => `${e}`}
                                    className="!px-0"
                                  />
                                </Col>
                                <Col xs={24} className="mb-5">
                                  <div className="!flex flex-col gap-2">
                                    {filter?.categoryUrl && filter?.categoryDescription && (
                                      <>
                                        <div>
                                          <Text className="!text-2xl !font-bold !text-black capitalize">
                                            {filter?.categoryDisplayUrl
                                              ?.replace(/-/g, " ")
                                              .replace(/\b\w/g, (char: string) => char.toLowerCase()) +
                                              " kategorisi hakkında daha fazla bilgi:" || ""}
                                          </Text>
                                        </div>
                                      </>
                                    )}
                                    {filter?.categoryDescription && (
                                      <div>
                                        <Text>{filter?.categoryDescription}</Text>
                                      </div>
                                    )}
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                          </>
                        );
                      } else if (viewingModes === "map") {
                        return <StatusViewingMap />;
                      }
                    })()}
                  </Row>
                ) : (
                  <CustomNoData />
                )}
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </>
  );
};

export default RealStateListIndex;